import React from "react";
import { formatUah } from "utils";
import { PermissionWrapper, InfoModal } from "components";

// Підкомпонент комірки "Ціна"
const PriceCell = ({ item, editing, setEditing, handleUpdate, handleKeyDown }) => (
  <PermissionWrapper
    requiredPermission="traps:edit"
    fallback={
      <td>
        {item.is_custom_price ? (
          <InfoModal
            info={[
              { label: "Оригінальна ціна", value: formatUah(item.original_price) },
            ]}
          >
            <span className="custom-price-text">{formatUah(item.price)}</span>
          </InfoModal>
        ) : item.price ? (
          formatUah(item.price)
        ) : (
          "---"
        )}
      </td>
    }
  >
    <td
      onDoubleClick={() =>
        setEditing({ field: "price", value: String(item.price ?? "") })
      }
    >
      {editing.field === "price" ? (
        <input
          type="number"
          value={editing.value}
          onChange={(e) => setEditing((prev) => ({ ...prev, value: e.target.value }))}
          onBlur={() => handleUpdate("price", editing.value)}
          onKeyDown={handleKeyDown}
          autoFocus
          min="0"
          step="1"
        />
      ) : item.is_custom_price ? (
        <InfoModal
          info={[
            { label: "Оригінальна ціна", value: formatUah(item.original_price) },
          ]}
        >
          <span className="custom-price-text">{formatUah(item.price)}</span>
        </InfoModal>
      ) : (
        formatUah(item.price)
      )}
    </td>
  </PermissionWrapper>
);

export default PriceCell;
